import React from "react";

import { Button } from "common/components/Atoms/Button";
import Modal from "common/components/Molecules/Modal";

interface ReferThankYouProps {
    isOpen: boolean;
    closeModal: () => void;
    job: {
        job_name: string;
    };
    onViewJobs: () => void;
    onGoToReferral: () => void;
}

export const ReferThankYou: React.SFC<ReferThankYouProps> = (
    props: ReferThankYouProps
) => {
    return (
        <Modal
            size="xs"
            title="thanks for the referral!"
            isOpen={props.isOpen}
            closeModal={props.closeModal}
        >
            <br />
            <div className="c-block">
                <p>
                    Thank you for submitting a referral for the{" "}
                    {props.job.job_name} position. Here's what happens next:
                </p>
                <ul>
                    <li>
                        One of our recruiters will review your referral's
                        qualifications.
                    </li>
                    <li>
                        Log in to your account at any time to track your
                        referral's progress.
                    </li>
                    <li>
                        Browse our other great jobs to find more referral
                        opportunities.
                    </li>
                </ul>
                <p>
                    Congrats, you're already a pro at this,
                    <br />
                    Team Relode
                </p>
            </div>
            <div className="c-modal__footer">
                <div className="c-modal__footer-left">
                    <Button
                        id="thanks-referral-view-all-jobs-button"
                        type="submit"
                        green={true}
                        onClick={props.onViewJobs}
                    >
                        view all jobs
                    </Button>
                </div>
                <div className="c-modal__footer-right">
                    <Button
                        id="thanks-referral-view-referral-status-button"
                        type="button"
                        onClick={props.onGoToReferral}
                    >
                        view referral stage
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
